/* BG COM : page Nos kits (sections/bgcom-kits-hub). Sorti du HTML le 03/10/2026, chargé en defer. */
(function(){
  var root = document.getElementById('bkh-root'); if(!root || root.dataset.ready) return; root.dataset.ready = '1';
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, r){ return [].slice.call((r || root).querySelectorAll(s)); }
  var seg = root.querySelector('.bkh-seg'), pill = root.querySelector('.bkh-seg__pill'), tag = root.querySelector('[data-bkh-tag]');
  var conf = root.querySelector('[data-bkh-conf]');
  var state = { m: root.getAttribute('data-m0') }, shown = {};
  /* format de la boutique : €1.087,66 */
  function fmt(c){ var s = (Math.round(c) / 100).toFixed(2).split('.'); return '€' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1]; }
  /* prix pro d'une ligne : même calcul que les pages kit (bgcomWholesaleData = prix pro de la 1re variante) */
  function unit(li){
    var price = +li.getAttribute('data-price'), first = +li.getAttribute('data-first') || price;
    var w = root.getAttribute('data-pro') === '1' && window.bgcomWholesaleData && window.bgcomWholesaleData[li.getAttribute('data-pid')];
    return (w && first) ? Math.round(price * w / first) : price;
  }
  function kitTotal(kit){ return $$('.bkh-items li[data-pid]', kit).reduce(function(a, li){ return a + unit(li); }, 0); }
  function count(el, to){
    var from = shown[el.dataset.k || 'x'] != null ? shown[el.dataset.k] : to;
    if(RM || from === to){ el.innerHTML = fmt(to) + '<small>HT</small>'; shown[el.dataset.k] = to; return; }
    var t0 = performance.now(), d = 700; cancelAnimationFrame(el._r);
    (function f(t){ var p = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - p, 3); el.innerHTML = fmt(from + (to - from) * e) + '<small>HT</small>'; if(p < 1) el._r = requestAnimationFrame(f); else shown[el.dataset.k] = to; })(t0);
  }
  function movePill(){ var b = seg && seg.querySelector('[aria-selected="true"]'); if(!b) return; pill.style.width = b.offsetWidth + 'px'; pill.style.transform = 'translateX(' + (b.offsetLeft - 6) + 'px)'; }
  /* points : « n:x,y,côté,libellé » ou « 2-4:… » (comme les pages kit) */
  function dotsFor(fig, kit){
    if(fig.dataset.built) return; fig.dataset.built = '1';
    var lis = $$('.bkh-items li[data-pid]', kit);
    (fig.getAttribute('data-points') || '').split(/[;\n]+/).forEach(function(raw, j){
      var m = raw.trim().match(/^(\d+)(?:\s*[-à]\s*(\d+))?\s*:\s*([\d.]+)\s*,\s*([\d.]+)\s*(?:,\s*([GLDR]))?\s*(?:,\s*(.+))?$/i); if(!m) return;
      var a = +m[1], z = m[2] ? +m[2] : a, sd = (m[5] || '').toUpperCase(), left = sd ? (sd === 'G' || sd === 'L') : (+m[3] > 55);
      var lab = (m[6] || (lis[a - 1] ? lis[a - 1].querySelector('.bkh-r').textContent : '')).trim();
      var d = document.createElement('button'); d.type = 'button'; d.className = 'bkh-dot' + (left ? ' is-l' : '') + (z > a ? ' is-wide' : '');
      d.style.cssText = 'left:' + m[3] + '%;top:' + m[4] + '%;animation-delay:' + (250 + j * 70) + 'ms';
      d.dataset.a = a; d.dataset.z = z; d.setAttribute('aria-label', lab);
      d.innerHTML = (z > a ? a + '-' + z : a) + '<span class="bkh-dot__lab">' + lab.replace(/</g, '&lt;') + '</span>';
      fig.appendChild(d);
    });
  }
  function current(){ var c = root.querySelector('.bkh-chipbox:not([hidden]) .bkh-chip[aria-pressed="true"]'); return c ? c.getAttribute('data-bkh-pick') : null; }
  function show(id, swap){
    var kit = root.querySelector('[data-bkh-kit="' + id + '"]'), fig = root.querySelector('[data-bkh-fig="' + id + '"]'); if(!kit) return;
    $$('[data-bkh-kit]').forEach(function(k){ var on = k === kit; k.hidden = !on; k.classList.toggle('is-in', on); });
    $$('.bkh-items li', kit).forEach(function(li, i){ li.style.setProperty('--d', Math.min(i, 12)); });
    var tot = kit.querySelector('[data-bkh-tot]'); tot.dataset.k = 'cur'; count(tot, kitTotal(kit));
    if(tag) tag.textContent = kit.getAttribute('data-sub') || '';
    var paint = function(){ $$('[data-bkh-fig]').forEach(function(f){ f.hidden = f !== fig; f.classList.remove('is-out'); }); if(fig){ dotsFor(fig, kit); var im = fig.querySelector('img'); if(im) im.loading = 'eager'; } };
    var vis = $$('[data-bkh-fig]').filter(function(f){ return !f.hidden; })[0];
    if(swap && !RM && vis && vis !== fig){ vis.classList.add('is-out'); setTimeout(paint, 260); } else paint();
  }
  function setM(m, swap){
    state.m = m;
    $$('.bkh-seg [role="tab"]').forEach(function(b){ b.setAttribute('aria-selected', b.getAttribute('data-m') === m ? 'true' : 'false'); });
    movePill();
    $$('[data-bkh-chips]').forEach(function(c){ c.hidden = c.getAttribute('data-bkh-chips') !== m; });
    var id = current(); if(id) show(id, swap);
  }
  if(seg) seg.addEventListener('click', function(e){ var b = e.target.closest('[role="tab"]'); if(b) setM(b.getAttribute('data-m'), true); });
  root.addEventListener('click', function(e){
    var c = e.target.closest('[data-bkh-pick]');
    if(c){ $$('.bkh-chip', c.parentNode).forEach(function(x){ x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); }); show(c.getAttribute('data-bkh-pick'), true); return; }
    var k = e.target.closest('[data-bkh-cmp]');
    if(k){ var id = k.getAttribute('data-bkh-cmp'), ch = root.querySelector('[data-bkh-pick="' + id + '"]'), box = ch && ch.closest('[data-bkh-chips]');
      if(box){ setM(box.getAttribute('data-bkh-chips'), false); $$('.bkh-chip', box).forEach(function(x){ x.setAttribute('aria-pressed', x === ch ? 'true' : 'false'); }); show(id, true); }
      var sel = root.querySelector('[id^="bkh-sel-"]'); if(sel) sel.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' }); }
  });
  /* survol ligne ↔ point */
  function hl(kit, fig, i){
    $$('.bkh-items li[data-pid]', kit).forEach(function(li){ li.classList.toggle('is-hl', i != null && +li.getAttribute('data-i') === i); });
    if(fig) $$('.bkh-dot', fig).forEach(function(d){ var n = i == null ? -1 : i + 1; d.classList.toggle('is-hl', n >= +d.dataset.a && n <= +d.dataset.z); });
  }
  root.addEventListener('pointerover', function(e){
    var li = e.target.closest('.bkh-items li[data-pid]'), d = e.target.closest('.bkh-dot');
    var id = current(); if(!id) return; var kit = root.querySelector('[data-bkh-kit="' + id + '"]'), fig = root.querySelector('[data-bkh-fig="' + id + '"]');
    if(li) hl(kit, fig, +li.getAttribute('data-i'));
    else if(d){ $$('.bkh-items li[data-pid]', kit).forEach(function(x){ var n = +x.getAttribute('data-i') + 1; x.classList.toggle('is-hl', n >= +d.dataset.a && n <= +d.dataset.z); }); }
  });
  root.addEventListener('pointerout', function(e){
    if(e.relatedTarget && (e.relatedTarget.closest && (e.relatedTarget.closest('.bkh-items li[data-pid]') || e.relatedTarget.closest('.bkh-dot')))) return;
    var id = current(); if(!id) return; hl(root.querySelector('[data-bkh-kit="' + id + '"]'), root.querySelector('[data-bkh-fig="' + id + '"]'), null);
  });
  /* prix pro : quand l'appli a chargé ses données, on recalcule les totaux (pastilles, comparatif, kit affiché) */
  function proRefresh(){
    if(root.getAttribute('data-pro') !== '1' || !window.bgcomWholesaleData) return;
    $$('[data-bkh-kit]').forEach(function(kit){
      var id = kit.getAttribute('data-bkh-kit'), t = kitTotal(kit);
      $$('[data-bkh-ctot="' + id + '"]').forEach(function(el){ el.textContent = fmt(t); });
      var f = kit.querySelector('[data-bkh-free]'); if(f) f.textContent = t >= 30000 ? 'Franco de port' : 'Franco de port dès 300 € HT';
      if(!kit.hidden){ var tot = kit.querySelector('[data-bkh-tot]'); tot.dataset.k = 'cur'; count(tot, t); }
    });
  }
  [700, 1600, 3200, 6000].forEach(function(ms){ setTimeout(proRefresh, ms); });
  addEventListener('resize', movePill);
  setM(state.m, false);
  requestAnimationFrame(movePill);
})();
